import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'create-affiliate-dialog',
    templateUrl: './create-affiliate-dialog.component.html',
    styleUrls: ['./affiliate-manage.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class CreateAffiliateDialogComponent implements OnInit {
    form: FormGroup;

    constructor(
        private _formBuilder: FormBuilder,
        public dialogRef: MatDialogRef<CreateAffiliateDialogComponent>) { }
    ngOnInit() {
        this.form = this._formBuilder.group({
            code: [''],
            fullName: [''],
            gender: ['MALE'],
            email: [''],
            phone: [''],
        })
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onSubmit(): void {
        this.dialogRef.close(this.form.getRawValue());
    }
}